import React, { useState, useEffect } from "react";
import AutocompleteSelect from "./AutocompleteSelect";

import { find_districts, find_streets, find_buildings } from "../../activity";


function getDictionary(dictionary, field, value){

  
  if(!dictionary || !field || !value || !value[field] || !dictionary) return [];

  const {addresses} = dictionary;

  if(!addresses || !addresses[field]) return [];


  const result = Object.keys(addresses[field]).filter(id=>id==value[field]).map(id=>({_id: id, name: addresses[field][id].name})) || [];


  return result;
} 

function AddressFull({ value, dictionary, onChange, error = '', fieldsPath, title }) {


  console.log('error', error, error == "")

  

  const [loading, setLoading] = useState({
    district: false,
    street: false,
    house: false,
    corpus: false
  });

  const [districts, setDistricts] = useState(getDictionary(dictionary, 'district', value));
  const [streets, setStreets] = useState(getDictionary(dictionary, 'street', value));
  const [buildings, setBuildings] = useState(getDictionary(dictionary, 'building', value));
  const [corpuses, setCorpuses] = useState(getDictionary(dictionary, 'corpus', value));




  useEffect(()=>{
    async function api(params) {
      const res = await find_districts({});
      setDistricts(res);
    }
    if(districts.length < 10) api();
  }, [title]);


  useEffect(()=>{

    setStreets(getDictionary(dictionary, 'street', value));
    setBuildings(getDictionary(dictionary, 'building', value));
    setCorpuses(getDictionary(dictionary, 'corpus', value));

  
    const dictElemIndex = districts.findIndex(e=>e._id == value.district);
    if(dictElemIndex > -1) {
      const newObj = dictionary ? Object.assign({}, dictionary.addresses) : {};
      if(!newObj["district"]) newObj["district"] = {};
      newObj["district"][value.district] = Object.assign(districts[dictElemIndex]);
      onChange('dictionary.addresses', newObj);
    }


  },[ value.district]);

  useEffect(()=>{
    async function api(params) {
      const res = await find_buildings({id: value.street});
      setBuildings(res);
    }
    api();

    const dictElemIndex = streets.findIndex(e=>e._id == value.street);
    if(dictElemIndex > -1) {
      const newObj = dictionary ? Object.assign({}, dictionary.addresses) : {};
      
      if(!newObj["street"]) newObj["street"] = {};
      newObj["street"][value.street] = Object.assign(streets[dictElemIndex]);
      onChange('dictionary.addresses', newObj);
    }

  },[ value.street]);

  useEffect(()=>{
    const { corpuses } = buildings.find(b=>b._id == value.building) || {};
    setCorpuses(corpuses || [])
    
    const dictElemIndex = buildings.findIndex(e=>e._id == value.building);
    if(dictElemIndex > -1) {
     const newObj = dictionary ? Object.assign({}, dictionary.addresses) : {};
      if(!newObj["building"]) newObj["building"] = {};
      newObj["building"][value.building] = Object.assign(buildings[dictElemIndex]);
      onChange('dictionary.addresses', newObj);
    }
    
  }, [value.building]);


  useEffect(()=>{
    const dictElemIndex = corpuses.findIndex(e=>e._id == value.corpus);
    if(dictElemIndex > -1) {
      const newObj = dictionary ? Object.assign({}, dictionary.addresses) : {};
      if(!newObj["corpus"]) newObj["corpus"] = {};
      newObj["corpus"][value.corpus] = Object.assign(corpuses[dictElemIndex]);
      onChange('dictionary.addresses', newObj);
    }

  }, [value.corpus]);

  // Функции для асинхронной подгрузки данных (заглушки)
  const searchDistricts = async (query) => {
    setLoading(prev => ({ ...prev, district: true }));
      setDistricts(await find_districts({search: query}));
    // Здесь будет реальный API вызов
    setTimeout(() => {
      setLoading(prev => ({ ...prev, district: false }));
    }, 500);
  };

  const searchStreets = async (query) => {
    setLoading(prev => ({ ...prev, street: true }));
      setStreets(await find_streets({search: query, id: value.district}));
    setTimeout(() => {
      setLoading(prev => ({ ...prev, street: false }));
    }, 500);
  };

  const searchHouses = async (query) => {
    setLoading(prev => ({ ...prev, house: true }));
    // Здесь будет реальный API вызов
    setTimeout(() => {
      setLoading(prev => ({ ...prev, house: false }));
    }, 500);
  };

  const searchCorpus = async (query) => {
    setLoading(prev => ({ ...prev, corpus: true }));
    // Здесь будет реальный API вызов
    setTimeout(() => {
      setLoading(prev => ({ ...prev, corpus: false }));
    }, 500);
  };

  
  
  const _onChange = ({val, part}) =>{

    const out = Object.assign({},value);

    switch(part){
      case 'district':
        out['district'] = val;
        out['street'] = '';
        out['building'] = '';
        out['corpus'] = '';

        setStreets([]);
        setBuildings([]);
        setCorpuses([]);

        break;
      case 'street':
        out['street'] = val;
        out['building'] = '';
        out['corpus'] = '';

        setBuildings([]);
        setCorpuses([]);

        break;
      case 'building':
        out['building'] = val;
        out['corpus'] = '';

        setCorpuses([]);

        break;
      case 'corpus':
        out['corpus'] = val;   
    }

    onChange(fieldsPath, out);

  }

  return (
    <>
      {title && <span style={{ fontSize: '17px', margin: '24px 0 26px', display: 'flex' }}>{title}</span>}
      {error && <div className="invalid-feedback">{error}</div>}
      
      <div className={error !== "" ? 'is-invalid-address':''}>
      <div className={`form-row-plain two-cols  ${error ? 'is-invalid' : ''}`}>
        <div className="form-group">
          <label className="form-label">Район</label>
          <AutocompleteSelect
            value={value.district}
            onChange={(val) => _onChange({ val, part: 'district'})}
//              fieldsPath + '.district', val
            options={districts || []}
            placeholder="Оберіть район"
            loading={loading.district}
            onSearch={searchDistricts}
            error={error.district}
            fieldName="district"
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">Вулиця</label>
          <AutocompleteSelect
            value={value.street}
            onChange={(val) => _onChange({ val, part: 'street'})}
              //onChange(fieldsPath + '.street', val)}
            options={streets || []}
            placeholder="Оберіть вулицю"
            loading={loading.street}
            onSearch={searchStreets}
            error={error.street}
            fieldName="street"
          />
        </div>
      </div>

      <div className="form-row-plain two-cols">
        <div className="form-group">
          <label className="form-label">Будинок</label>
          <AutocompleteSelect
            value={value.building}
            onChange={(val) => _onChange({ val, part: 'building'})}
              //onChange(fieldsPath + '.building', val)}
            options={buildings || []}
            placeholder="Оберіть будинок"
            loading={loading.house}
            onSearch={searchHouses}
            error={error.house}
            fieldName="building"
          />
        </div>
        
        <div className="form-group">
          <label className="form-label">Корпус</label>
          <AutocompleteSelect
            value={value.corpus}
            onChange={(val) => _onChange({ val, part: 'corpus'})}
              //onChange(fieldsPath + '.corpus', val)}
            options={corpuses || []}
            placeholder="Оберіть корпус"
            loading={loading.corpus}
            onSearch={searchCorpus}
            error={error.corpus}
            fieldName="corpus"
          />
        </div>
      </div>
      </div>
    
    </>
  );
}

export default AddressFull;